import React from "react";
import { useDispatch, useSelector } from "react-redux";
import MultiSelect from "../Selectors/MultiSelect";
import { loadStores } from "../../../api_calls/campaigns";
import { updateStateData } from "../../../Store/actions";
import { Box, Stack } from "@mui/material";
import { TextButtonStyle } from "../Buttons/Styles";
import StoreSelectionModal from "./StoreSelectionModal";

const DetailedStoreFilter = ({ reduxKeywordToSaveValue }) => {
    const storeDetails = useSelector((state) => state.userSelections);
    const [defaultValuesLoaded, setDefaultValuesLoaded] = React.useState(false);
    const [changesMade, setChangesMade] = React.useState(false);
    const [showSelectionModal, setShowSelectionModal] = React.useState(false);

    const [storeNameOptionSelected, setStoreNameOptionsSelected] = React.useState([]);
    const dispatchAction = useDispatch();
    const storeList = storeDetails?.stores_list
        ? [...storeDetails.stores_list.map((storeInfo) => {
            return storeInfo.name;
        })].sort()
        : [];

    const fetchStoreIds = (storeNames) => {
        const reformStoreNames = Array.isArray(storeNames) ? storeNames : [storeNames];

        let storeIds =
            typeof storeDetails.stores_list !== "undefined" && storeDetails.stores_list.length !== 0 && reformStoreNames.length !== 0
                ? storeDetails.stores_list.filter(storeListOptions => reformStoreNames.includes(storeListOptions.name)).map(store => store.id)
                : [];

        return storeIds;
    }

    React.useEffect(() => {
        loadStores().then(() => {
            setDefaultValuesLoaded(true);
        })
    }, []);

    React.useEffect(() => {
        if (storeDetails?.[reduxKeywordToSaveValue]?.selected_store_names) {
            setStoreNameOptionsSelected(storeDetails[reduxKeywordToSaveValue].selected_store_names);
        }
    }, [storeDetails, reduxKeywordToSaveValue]);

    return defaultValuesLoaded ? (
        <>
            <Box width={"100%"}>
                <MultiSelect
                    enableFullWidth={true}
                    label={"Store"}
                    options={[...storeList].map((storeName) => {
                        return { value: storeName, label: storeName };
                    })}
                    defaultVal={storeNameOptionSelected}
                    selectionCheck={(option, value) => option.label === value.label}
                    usedFor="storeFilter"
                    onChangeCall={(selectedOption) => {
                        setChangesMade(true);
                        setStoreNameOptionsSelected(selectedOption);
                    }}
                    onBlurCall={(e) => {
                        if (changesMade === true) {
                            const storeNames = storeNameOptionSelected.length !== 0 ? storeNameOptionSelected.map(store => store.label) : [];
                            const StoreIds = storeNameOptionSelected.length !== 0 ? fetchStoreIds(storeNames) : [];

                            dispatchAction(
                                updateStateData({
                                    [reduxKeywordToSaveValue]: {
                                        ...storeDetails[reduxKeywordToSaveValue],
                                        "store_ids": StoreIds,
                                        "selected_store_names": storeNameOptionSelected
                                    },
                                })
                            );

                            // filterSingleValue("id-campaign", StoreIds, vizId);
                            setChangesMade(false);
                        }
                    }}
                />
            </Box>
            <Box height={2} />
            <Box
                sx={{
                    display: "flex",
                    justifyContent: "flex-end",
                    mt: 0.5,
                }}
            >
                <TextButtonStyle
                    sx={{
                        px: 0.1,
                        fontWeight: 400,
                    }}
                    onClick={(e) => {
                        setShowSelectionModal(true);
                    }}> Detailed Selection</TextButtonStyle>
            </Box>
            {
                showSelectionModal && (
                    <StoreSelectionModal
                        open={showSelectionModal}
                        onClose={() => setShowSelectionModal(false)}
                        storeSelectionReduxKey={reduxKeywordToSaveValue}
                    />
                )
            }
        </>
    ) : (
        <></>
    );
};

export default DetailedStoreFilter;
